module.exports = __webpack_public_path__ + "static/media/orangeWig.0b459c03.png";